export default __webpack_public_path__ + "static/media/twitter.53ca3a70.svg";